export default "__VITE_ASSET__CtQkNA3G__"